import { CanDeactivateFn } from "@angular/router";
import { ManagerEvaluationComponent } from "./manager-evaluation.component";

/**
 * CanDeactivate guard per la pagina della valutazione del manager.
 *
 * C-1-T16 (UX-01, SPEC 6.14) - sulla scheda STANDARD, con testo non salvato, apre la modale «Modifiche non salvate» e
 * aspetta la scelta: «Prosegui» salva e lascia uscire, Annulla tiene il manager sulla scheda. Le altre schede escono
 * come prima.
 */
export const managerEvaluationCanDeactivate: CanDeactivateFn<ManagerEvaluationComponent> =
  (component) => component.guardPendingChanges();
